<template>
  <div class="card-icon" :class="[background, {'disabled': disabled}]">
    <i :class='"sofont " + icon + (disabled?" disabled":"")' :style="getStyles()"></i>
  </div>
</template>

<script src="./card-icon.js"></script>
<style scoped lang="scss" src="./card-icon.scss"></style>
